module.exports = __webpack_public_path__ + "img/jobmule_candidati.d894de06.png";